import { createContext } from "react";

const EstudiosLaboratorioContext = createContext();

export default EstudiosLaboratorioContext;
